import React, { useContext, useState, useReducer, useEffect } from 'react'
import Modal from "react-bootstrap/Modal"; // if you are using react-bootstrap
import { useForm } from 'react-hook-form';
import { useDataIngestion } from '../../../Hooks/useDataIngestion';
import VisitorParamsContext from '../../../Contexts/VisitorParams';
import { AddPouchDBData } from '../../../Utility/pouchdbService';
import QueryStringContext from '../../../Contexts/QueryString';
import RadioButtonV2 from '../../UI/RadioButtonV2';
import { usePhoneValidation } from '../../../Hooks/usePhoneValidation';
import { useEmailValidation } from '../../../Hooks/useEmailValidation';
import orangetickicon from '../../../assets/SNR_BNFTS_V2/img/orange-tick-icon.png';
import gtick from '../../../assets/SNR_BNFTS_V2/img/g-tick.png';
import tqimg from '../../../assets/SNR_BNFTS_V2/img/tq-img.png';
import doticon from '../../../assets/SNR_BNFTS_V2/img/dot-icon.gif';
import Dob from '../Layouts/ADV_2/Dob';
import Postcode from '../Layouts/ADV_2/Postcode';
import PersonalDetails from '../Layouts/ADV_2/PersonalDetails';
import ContactDetails from '../Layouts/ADV_2/ContactDetails';
import orange from "../../../assets/SNR_BNFTS_V2/img/orange-tick-icon.png"
import icon from "../../../assets/SNR_BNFTS_V2/img/icon2.gif"
import confetti from 'canvas-confetti';
import GTMDataLayer from '../../../Utility/GTMDataLayer';
import { ClearAllPouchDBData } from '../../../Utility/pouchdbService';

const initialState = {
	showSlide1: 'show',
	showSlide2: 'hide',
	showSlide3: 'hide',
	showSlide4: 'hide',
	showSlide5: 'hide',
	showSlide6: 'hide',
};
const FormReducer = (state, action) => {
	switch (action.type) {
		case 'showSlide': {
			if (action.payload.clickedSlide.slide === 'next1') {
				return {
					...state,
					showSlide1: 'hide',
					showSlide2: 'show',
				};
			} else if (action.payload.clickedSlide.slide === 'next2') {
				return {
					...state,
					showSlide2: 'hide',
					showSlide3: 'show',
				};
			} else if (action.payload.clickedSlide.slide === 'question_1') {
				return {
					...state,
					showSlide3: 'hide',
					showSlide4: 'show',
				};
			} else if (action.payload.clickedSlide.slide === 'next4') {
				return {
					...state,
					showSlide4: 'hide',
					showSlide5: 'show',
				};
			} else if (action.payload.clickedSlide.slide === 'next5') {
				return {
					...state,
					showSlide5: 'hide',
					showSlide6: 'show',
				};
			}
			else {
				return {
					...state,
				};
			}
		}
		default:
			return state;
	}
};

const AdvModal = (props) => {
	const {
		register,
		formState: { errors },
		trigger,
		setError,
		clearErrors,
		getValues,
	} = useForm({
		mode: 'onBlur',
		reValidateMode: 'onChange',
		defaultValues: {},
		resolver: undefined,
		context: undefined,
		criteriaMode: 'firstError',
		shouldFocusError: true,
		shouldUnregister: true,
	});
	const urlParams = new URLSearchParams(window.location.search);
	const [state, dispatch] = useReducer(FormReducer, initialState);
	const { saveDataIngestion, isLoading } = useDataIngestion();
	const { visitorParameters } = useContext(VisitorParamsContext);
	const splitName = urlParams.get('adv_page') || '2025_art/senior_benefits/v2';
	const { queryString } = useContext(QueryStringContext);
	const [showLoader, setShowLoader] = useState(true);


	const handleSlideChange = (e) => {
		var slide = { slide: e.target.name };
		if(slide.slide === 'question_1'){
			GTMDataLayer({
			clickEvent: 'slideclick',
			question: 'car finance agreement',
			answer: '',
		});
		}
		if (slide.slide === 'next5') {
			console.log('props.url',props.url);
			setShowLoader("analyzing");
			setTimeout(() => {
				setShowLoader(false);
				launchModalConfetti();
				setTimeout(() => {
					ClearAllPouchDBData();
					window.location.href = props.url;
				}, 2000);
			}, 3000);
		}
		dispatch({ type: 'showSlide', payload: { clickedSlide: slide } });
	};

	useEffect(() => {
		if (props.showModal) {
			setShowLoader(true);
			setTimeout(() => {
				setShowLoader(false);
			}, 2000);
		}
	}, [props.showModal]);

	const formSubmit = async () => {
		const values = getValues();
		const formData = values;
		formData.question_answer_1 = {
			label: 'Have You Taken Out At Least 1 Car on Finance Since 2007?',
			value: values.question_1 == 1 ? 'Yes' : 'No',
		}
		const fields = [
			'txtHouseNumber',
			'txtAddress2',
			'txtAddress3',
			'txtAddress4',
			'txtCounty',
			'txtTown',
			'txtCountry',
			'txtDistrict',
			'locality',
		];
		fields.forEach((fieldId) => {
			const field = document.getElementById(fieldId);
			if (field) {
				formData[fieldId] = field.value;
			}
		});
		formData.page_name = splitName;
		visitorParameters.data.page_type = 'LP';
		if (
			visitorParameters.data !== null ||
			visitorParameters.data !== undefined
		) {
			await AddPouchDBData('formData', formData);
			const formSUbmitResult = await saveDataIngestion(
				visitorParameters.visitor_parameters,
				formData,
				'split_form_submit',
				splitName,
				queryString,
				visitorParameters.data
			);
			if (formSUbmitResult.data.status == "Success") {
				handleSlideChange({ target: { name: 'next5' } });

			}

		}
	};

	const launchModalConfetti = () => {
		const duration = 2000; // 2 seconds
		const end = Date.now() + duration;
	  
		(function frame() {
		  confetti({
			particleCount: 7,
			spread: 80,
			origin: { y: 0.6 },
			zIndex: 1055,
		  });
	  
		  if (Date.now() < end) {
			requestAnimationFrame(frame);
		  }
		})();
	  };
	
	return (
		<>

			{/*

			<Modal
				show={props.showModal}
				onHide={() => props.setShowModal(false)}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Body>
					
					<div className="modal-body" style={{  top: '65px',
    borderRadius: '25px'}}> */}

			{/* <div 
show={props.showModal}
onHide={() => props.setShowModal(false)}
backdrop="static"
keyboard={false}
id="exampleModal"
tabIndex="-1"

> */}
			<Modal
				show={props.showModal}
				onHide={() => props.setShowModal(false)}
				backdrop="static"
				keyboard={false}
			>
					<Modal.Body>
				{/* <div class="modal-dialog form-modal">
					<div class="modal-content"> */}
						{/* <div class="modal-body"> */}
							<div className="popup-slider">
								{showLoader ? (
									<div className="slide loader">
										<div className="tick-top-icon">
											<img src={orange} alt="tick" />
										</div>
										<div className="loderimg">
											<img height="100px" src={icon} alt="Loading..." />
										</div>
										{showLoader === "analyzing" && <p>Analyzing your information...</p>}
									</div>
								) : (
									<>
										<div className="slide active">
											<span className={`${state.showSlide6 == 'show' ? 'hide' : 'show'}`}>
												<div className="tick-top-icon ">
													<img src={orangetickicon} alt="tick" />
												</div>
												<h6 className="text-center">Just a few quick questions to see if you pre-qualify for a claim - it only takes a minute!</h6>
											</span>
											<form>
												<Dob
													slideStatus={state.showSlide1}
													slideChange={handleSlideChange}
													register={register}
													validationMsg={errors}
													trigger={trigger}
													clearErrors={clearErrors}
													getValues={getValues}
												/>
												<Postcode
													slideStatus={state.showSlide2}
													slideChange={handleSlideChange}
													register={register}
													validationMsg={errors}
													trigger={trigger}
													clearErrors={clearErrors}
													getValues={getValues}
													setError={setError}
												/>
												<div className={` ${state.showSlide3} `}>
												<label class="mt-3 "  style={{fontSize:"18px",textAlign:"center"}} htmlFor="Date of Birt">Have You Taken Out At Least 1 Car Finance Agreement Since 2007?</label>
												<div className="d-flex gap-2 align-items-center">
														<RadioButtonV2
															className="next-btn mt-0"
															type="radio"
															id="question_1_yes"
															labelClassName="next-btn mt-0 ynbtnw "
															labelName="Yes"
															value="1"
															onChange={handleSlideChange}
															register={register('question_1')}
															labelClass="ynbtn"
														/>
														<RadioButtonV2
															className="next-btn mt-0"
															type="radio"
															id="question_1_no"
															labelClassName="next-btn mt-0 ynbtnw "
															labelName="No"
															value="2"
															onChange={handleSlideChange}
															register={register('question_1')}
															labelClass = "ynbtn"
														/>
													</div>
												</div>
												<PersonalDetails
													slideStatus={state.showSlide4}
													slideChange={handleSlideChange}
													register={register}
													validationMsg={errors}
													trigger={trigger}
													clearErrors={clearErrors}
												/>
												<ContactDetails
													slideStatus={state.showSlide5}
													slideChange={handleSlideChange}
													register={register}
													validationMsg={errors}
													trigger={trigger}
													clearErrors={clearErrors}
													getValues={getValues}
													setError={setError}
													formSubmit={formSubmit}
												/>
											</form>
										</div>

										<div className={`slide-6 text-center ${state.showSlide6}`} id="slide-6">
											<div className="congrats-outer text-center"><img className="congrats_img" src={tqimg} alt="" /></div>
											<h3 className="congrats-text conf-txt">Congratulations!</h3>
											<h4 className="mt-2 mb-3"><img className="tick-g" src={gtick} alt="" /> You’ve Pre-Qualified</h4>
											
											<p className="spl">You're one step closer to making your claim. Based on your answers, you’ve pre-qualified for the final stage of the process.</p>
											<p>Please Wait <img height="25" src={doticon} alt="" /></p>
										</div>

										<div class="steps-box">
											<p className={`text-center mt-3 ${state.showSlide6 == 'show' ? 'hide' : 'show'}`}>Unlock Your Right to Claim in Just a Few Steps</p>
										</div>
									</>
								)}
							</div>


						{/* </div> */}
					{/* </div>
				</div> */}
				</Modal.Body>
			</Modal>
		</>
	)
}

export default AdvModal